module.exports = __webpack_public_path__ + "static/media/plus-circle-solid.4c5f95ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus-circle-solid.svg
// module id = 924
// module chunks = 58